// @ts-nocheck
import { Input } from '@alefeducation/ui-elements-library-core';
import { AngleRight } from '@alefeducation/ui-elements-library-icons';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import RenderIf from '../Common/renderIf';
import './pagination.scss';

interface SelectOptionType {
  label: string;
  value: number;
}

export interface PaginationPropsType {
  selectedPageSizeOption?: number;
  rowsPerPageOptions: Array<number>;
  onSelection: (value: number) => void;
  setPageIndex: (page: number) => void;
  totalRecords: number;
  currentPage: number;
  goToNextPage: () => void;
  goToPrevPage: () => void;
  compactPagination?: boolean;
}

const selectOptionMapper = (option: string | number) => ({
  label: option?.toString(),
  value: Number(option),
});

const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);

const style = {
  control: (base) => ({
    ...base,
    border: '1px solid #B6BBC1',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #B6BBC1',
    },
  }),
  option: (baseStyle) => ({
    ...baseStyle,
    padding: '12px 9px',
    borderRadius: 8,
    backgroundColor: 'transparent',
  }),
  menuList: (baseStyle) => ({
    ...baseStyle,
    padding: 8,
    lineHeight: 1,
    borderRadius: 8,
  }),
  menu: (baseStyle) => ({
    ...baseStyle,
    borderRadius: 8,
    zIndex: 5,
  }),
};
const Pagination = (props: PaginationPropsType) => {
  const {
    selectedPageSizeOption,
    rowsPerPageOptions,
    onSelection,
    totalRecords,
    currentPage,
    goToNextPage,
    goToPrevPage,
    setPageIndex,
    compactPagination,
  } = props;

  const [rowsPerPage, setRowsPerPage] = useState<number>(rowsPerPageOptions[0]);
  const [selectOptions, setSelectOptions] = useState<Array<SelectOptionType>>(
    [],
  );
  const [currentPageInput, setCurrentPageInput] = useState<
    number | undefined
  >();

  useEffect(() => {
    setCurrentPageInput(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (selectedPageSizeOption) {
      setRowsPerPage(selectedPageSizeOption);
    }
  }, [selectedPageSizeOption]);

  useEffect(() => {
    if (rowsPerPageOptions) {
      setSelectOptions(rowsPerPageOptions.map(selectOptionMapper));
    }
  }, [rowsPerPageOptions]);

  const onSelectChange = (option: SelectOptionType) => {
    onSelection(option.value);
  };

  const onCurrentPageInputChange = (e) => {
    const value = e.target.value;
    if (
      (isNumeric(value) && value > 0 && value <= totalPages) ||
      value === ''
    ) {
      setCurrentPageInput(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') setPageIndex(currentPageInput);
  };

  const showingRecordsFrom = currentPage * rowsPerPage - rowsPerPage + 1;
  const showingRecordsTo = currentPage * rowsPerPage;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const disableNext = currentPage === totalPages;
  const disableBack = currentPage === 1;

  return (
    <div className="alef-pagination text-blsl ">
      <RenderIf condition={!compactPagination}>
        <span className="alef-pagination__data-rows-info">Rows per page</span>
        <div className="alef-pagination__data-rows-select">
          <Select
            data-testid="alef-pagination-select"
            name="number-of-rows"
            placeholder=""
            options={selectOptions}
            value={selectOptionMapper(selectedPageSizeOption)}
            defaultValue={selectOptionMapper(selectedPageSizeOption)}
            onChange={onSelectChange}
            className="alef-pagination__alef-select-root"
            classNamePrefix="alef-select"
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator: () => null,
            }}
            isSearchable={false}
            menuPlacement="top"
            styles={style}
          />
        </div>
      </RenderIf>
      <div className="alef-pagination__data-rows-records">{`${showingRecordsFrom}-${
        showingRecordsTo < totalRecords ? showingRecordsTo : totalRecords
      } of ${totalRecords}`}</div>
      <div className="alef-pagination__page-selector">
        <AngleRight
          onClick={goToPrevPage}
          width={18}
          height={18}
          color={disableBack ? '#9198A3' : '#485465'}
        />
        <RenderIf condition={!compactPagination}>
          <div className="alef-pagination__page-selector-info">
            Page{' '}
            <Input
              value={currentPageInput}
              onChange={onCurrentPageInputChange}
              className="text-blsl"
              onKeyDown={handleKeyDown}
              data-testid="datagrid-page-input-selector"
            />{' '}
            of {totalPages}
          </div>
        </RenderIf>
        <AngleRight
          onClick={goToNextPage}
          width={18}
          height={18}
          color={disableNext ? '#9198A3' : '#485465'}
        />
      </div>
    </div>
  );
};

export default Pagination;
